import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getSalesPlanStart,
} from "../../../Store/Slices/salesPlanSlice";

const TargetAchievement = () => {
  const [expandedNodes, setExpandedNodes] = useState({});
  const dispatch = useDispatch();
  const location = useLocation();
  const salesPlanData = useSelector(
    (state) => state?.salesPlan?.salesPlanData || []
  );
  const passedSalesPlan = location.state?.salesPlanData;
  console.log('Passed Sales Plan:', JSON.stringify(passedSalesPlan, null, 2));
  console.log('salesPlanData', JSON.stringify(salesPlanData, null, 2));

  useEffect(() => {
    dispatch(getSalesPlanStart());
  }, [dispatch]);

  useEffect(() => {
    if (passedSalesPlan) {
      const initialExpanded = {};
      const setInitialExpanded = (nodes) => {
        nodes.forEach((node) => {
          initialExpanded[node.id] = true;
          if (node.children?.length) {
            setInitialExpanded(node.children);
          }
        });
      };
      setInitialExpanded(passedSalesPlan.data?.target_data || []);
      setExpandedNodes(initialExpanded);
    }
  }, [passedSalesPlan]);

  const toggleNode = (id) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const formatNumber = (value) => {
    if (value === "" || value === null || value === undefined) return "$0";
    const num = parseFloat(value);
    if (isNaN(num)) return "$0";
    return `$${Math.floor(num).toLocaleString()}`;
  };

  const getTargetValue = (node) => {
    if (node.type === "user") {
      return formatNumber(node.child_value || "0");
    }
    if (node.type === "role" || node.type === "territory") {
      return node.role_value2 && node.role_value2 !== ""
        ? formatNumber(node.role_value2)
        : formatNumber(node.role_value1 || "0");
    }
    return "$0";
  };

  const renderNode = (node, level = 0) => {
    const isCompany = node.type === "company";
    const isRole = node.type === "role" || node.type === "territory";
    const isUser = node.type === "user";
    const nodeId = node.id || `${node.name}-${level}`;
    const initials = isUser ? node.name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase() : null;

    return (
      <div className="d-flex" key={nodeId}>
        <div className="d-flex flex-column align-items-center" style={{ width: '40px' }}>
          {level > 0 && <div className="bg-secondary" style={{ width: '2px', height: '20px' }}></div>}
          {(node.children?.length > 0 || isCompany) && (
            <div
              className="bg-light border rounded-circle d-flex align-items-center justify-content-center mb-1"
              style={{ width: '24px', height: '24px', cursor: 'pointer' }}
              onClick={() => toggleNode(nodeId)}
            >
              <span className="text-muted">{expandedNodes[nodeId] ? '−' : '+'}</span>
            </div>
          )}
          {(node.children?.length > 0 || isCompany) && expandedNodes[nodeId] && (
            <div className="bg-secondary" style={{ width: '2px', height: '20px' }}></div>
          )}
        </div>

        <div className="flex-grow-1">
          <div className="row">
            <div className="col-12 col-md-4">
              <div className="card mb-3 shadow-sm">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center mb-3">
                    {isUser && (
                      <div className="bg-light rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: '40px', height: '40px' }}>
                        <span className="text-muted">{initials}</span>
                      </div>
                    )}
                    <h6 className="mb-0">{node.name}</h6>
                    {isRole && <span className="badge bg-light text-dark ms-2">{node.children?.length || 1}</span>}
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="me-4">
                      <div className="text-muted small mb-1">Self Target</div>
                      <div className="fw-bold">{isUser ? formatNumber(node.child_value || "0") : formatNumber(node.target_value || "0")}</div>
                    </div>
                    <div>
                      <div className="text-muted small mb-1">Team Target</div>
                      <div className="fw-bold">{formatNumber(node.secondary_value || "0")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {expandedNodes[nodeId] && node.children?.length > 0 && (
            <div className="d-flex">
              <div style={{ width: '40px' }}></div>
              <div className="flex-grow-1">
                {node.children.map((child) => renderNode(child, level + 1))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const companyTarget = passedSalesPlan?.data?.sales_plan_target || "0";
  const companyName = passedSalesPlan?.data?.sales_plan_name || "Digylax Private Limited";
  const salesPlanPeriod = passedSalesPlan?.data?.sales_plan_period || "Q1 2025";

  return (
    <div className="container-fluid p-0">
      <div className="d-flex align-items-center mb-3 px-3 py-2 border-bottom">
        <button className="btn btn-link text-decoration-none text-dark p-1 me-2">
          <i className="bi bi-arrow-left"></i>
        </button>
        <h5 className="mb-0 me-2">{companyName} - {salesPlanPeriod}</h5>
      
        <div className="ms-auto d-flex align-items-center">
        
          <button className="btn btn-link text-decoration-none text-dark p-1">
            <i className="bi bi-info-circle"></i>
          </button>
        </div>
      </div>

      <div className="px-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0 fw-bold">Target achievement report</h6>
          <div className="d-flex align-items-center">
            <i className="bi bi-sliders text-warning"></i>
          
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-4">
            <div className="card mb-3 shadow-sm">
              <div className="card-body p-3">
                <h6 className="mb-3">{companyName}</h6>
                <div className="row gx-3">
                  <div className="col-12">
                    <div className="text-muted small mb-1">Target</div>
                    <div className="fw-bold">{formatNumber(companyTarget)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {passedSalesPlan?.data?.target_data?.length > 0 ? (
          passedSalesPlan.data.target_data.map((role) => renderNode({
            ...role,
            type: "territory",
            expanded: expandedNodes[role.id] || true,
          }))
        ) : (
          <p>No hierarchy data available.</p>
        )}
      </div>
    </div>
  );
};

export default TargetAchievement;